<template>
  <GenericButton
    svg="website"
    link="https://www.fonline-reloaded.net/"
    title="Official Website"
  />
  <GenericButton
    svg="forum"
    link="https://forum.fonline-reloaded.net/index.php"
    title="Forums"
  />
  <GenericButton
    svg="discord"
    link="https://discord.gg/qj4wVv7"
    title="Discord"
  />
  <GenericButton
    svg="wiki"
    link="https://www.fonline-reloaded.net/wiki/Main_Page"
    title="FOnline: Reloaded Wiki"
  />
</template>

<script>
import { useStore } from "vuex"
import { defineComponent } from "vue"
import GenericButton from "../GenericButton.vue"
export default defineComponent({
 name: "CommunityLinks",
 components: { GenericButton },
 setup() {
   const store = useStore()
      
    return {
      state: store.state,
   }
 },
})
</script>